// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upcomingEvent_banner {
    background: #FFEEF3;
    /* padding: 100px; */
}
.event_page_details_container {
    background: #FFEEF3;
    padding: 55px;
}
.upcomingEvent_container .paragraphs p
{
margin-bottom: 30px;
}
.upcomingEvent_container .upcomingEvent_banner .container {
    overflow: hidden;
    position: relative;
    padding: 100px 250px  100px 0px;
    z-index: 2;
}
.upcomingEvent_container .upcomingEvent_banner img 
{
    width: 100%;
    height: 116%;
    position: absolute;
    object-fit: contain;
    z-index: -1;
    top: 0px;
    right: 325px;
}
.event_page_details_name {
    display: flex;
    margin-bottom: 20px;
    align-items: center;
}
.event_page_details_name span {
    font-size: 50px;
    margin-right: 30px;
}
.event_page_details_title {
    font-size: var(--f20);
    font-weight: 700;
}
.event_page_details_para {
    font-size: var(--pSize);
    font-weight: 400;
}
.application_process h3
{
font-size: var(--f20);
font-weight: 700;
}
.application_process ul
{
margin-top: 50px;
}

.application_process li
{
margin-bottom: 20px;
}

.application_process_btns .apply_now
{
    padding: 10px 30px;
    border-radius: 25px;
}
.application_process_btns .apply_now:first-child
{
  background-color: #E20F6F;
  color: #fff;
}
.application_process_btns .apply_now:last-child
{
  background-color: transparent;
  border:1px solid #977CFF;
  color: var(--dPink);
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/UpcomingEvents.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;;AAEA,mBAAmB;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;AACd;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,QAAQ;IACR,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;;AAEA,qBAAqB;AACrB,gBAAgB;AAChB;AACA;;AAEA,gBAAgB;AAChB;;AAEA;;AAEA,mBAAmB;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;EAEE,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".upcomingEvent_banner {\n    background: #FFEEF3;\n    /* padding: 100px; */\n}\n.event_page_details_container {\n    background: #FFEEF3;\n    padding: 55px;\n}\n.upcomingEvent_container .paragraphs p\n{\nmargin-bottom: 30px;\n}\n.upcomingEvent_container .upcomingEvent_banner .container {\n    overflow: hidden;\n    position: relative;\n    padding: 100px 250px  100px 0px;\n    z-index: 2;\n}\n.upcomingEvent_container .upcomingEvent_banner img \n{\n    width: 100%;\n    height: 116%;\n    position: absolute;\n    object-fit: contain;\n    z-index: -1;\n    top: 0px;\n    right: 325px;\n}\n.event_page_details_name {\n    display: flex;\n    margin-bottom: 20px;\n    align-items: center;\n}\n.event_page_details_name span {\n    font-size: 50px;\n    margin-right: 30px;\n}\n.event_page_details_title {\n    font-size: var(--f20);\n    font-weight: 700;\n}\n.event_page_details_para {\n    font-size: var(--pSize);\n    font-weight: 400;\n}\n.application_process h3\n{\nfont-size: var(--f20);\nfont-weight: 700;\n}\n.application_process ul\n{\nmargin-top: 50px;\n}\n\n.application_process li\n{\nmargin-bottom: 20px;\n}\n\n.application_process_btns .apply_now\n{\n    padding: 10px 30px;\n    border-radius: 25px;\n}\n.application_process_btns .apply_now:first-child\n{\n  background-color: #E20F6F;\n  color: #fff;\n}\n.application_process_btns .apply_now:last-child\n{\n  background-color: transparent;\n  border:1px solid #977CFF;\n  color: var(--dPink);\n  margin-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
